import React from 'react'
import Footer from './Footer'
import Header from './Header'

function ContactInHeader() {
  return (
     <>
        <Header/>
        <div class="pt-14">
        <Footer/>
        </div>
        </>
  )
}

export default ContactInHeader